<template lang="html">
  <div id="baseBody">
    <div id="blurBase">
      <div id="mapBase" style="width: 100vw; height: 100vh;"></div>

      <div id="hogeHokkaido" class="preMap">
        <p>HOKKAIDO<span class="number">{{number.hokkaido.img}}</span></p>
      </div>

      <div id="hogeTokyo" class="preMap">
        <p>TOKYO<span class="number">{{number.tokyo.img}}</span></p>
      </div>

      <div id="hogeGunma" class="preMap">
        <p>GUNMA<span class="number">{{number.gunma.img}}</span></p>
      </div>

      <div id="hogeShizuoka" class="preMap">
        <p>SHIZUOKA<span class="number">{{number.shizuoka.img}}</span></p>
      </div>

      <div id="hogeOsaka" class="preMap">
        <p>OSAKA<span class="number">{{number.osaka.img}}</span></p>
      </div>

      <div id="hogeHyogo" class="preMap">
        <p>HYOGO<span class="number">{{number.hyogo.img}}</span></p>
      </div>

      <div id="hogeFukuoka" class="preMap">
        <p>FUKUOKA<span class="number">{{number.fukuoka.img}}</span></p>
      </div>

      <div id="hogeKagoshima" class="preMap">
        <p>KAGOSHIMA<span class="number">{{number.kagoshima.img}}</span></p>
      </div>
    </div>

    <div id="hover">
      <div id="base">
        <h1>テスト</h1>
        <div class="people">
          <ul v-for="member of selectMember" :key="member.name">
            <li>
              <img :src="member.image" />
              <div class="name">
                <p>{{member.Name}}</p>
                <p class="little">{{member.Alphabet}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div id="text">
      <ul>
        <li class="pre" id="hokkaido"><span class="Blank">{{number.hokkaido.num}}</span><span class="Blank2">|</span> HOKKAIDO</li>
        <li class="pre" id="gunma"><span class="Blank">{{number.gunma.num}}</span><span class="Blank2">|</span> GUNMA</li>
        <li class="pre" id="hyogo"><span class="Blank">{{number.hyogo.num}}</span><span class="Blank2">|</span> HYOGO</li>
        <li class="pre" id="tokyo"><span class="Blank">{{number.tokyo.num}}</span><span class="Blank2">|</span> TOKYO</li>
        <li class="pre" id="shizuoka"><span class="Blank">{{number.shizuoka.num}}</span><span class="Blank2">|</span> SHIZUOKA</li>
        <li class="pre" id="osaka"><span class="Blank">{{number.osaka.num}}</span><span class="Blank2">|</span> OSAKA</li>
        <li class="pre" id="fukuoka"><span class="Blank">{{number.fukuoka.num}}</span><span class="Blank2">|</span> FUKUOKA</li>
        <li class="pre" id="kagoshima"><span class="Blank">{{number.kagoshima.num}}</span><span class="Blank2">|</span> KAGOSHIMA</li>
      </ul>
    </div>

    <!-- スライダー -->
    <div id="slider">
      <label>
        <span class="point">-</span><input type="range" id="sliderValue" min="40" max="90" value="40" /><span class="point">+</span>
      </label>
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "mapPage",
  components: {
  },
  data () {
    return {
      osaka: [],
      fukuoka: [],
      tokyo: [],
      shizuoka: [],
      kagoshima: [],
      hokkaido: [],
      hyogo: [],
      gunma: [],
      number: {
        osaka: {num: 0, img: "⓪"},
        tokyo: {num: 0, img: "⓪"},
        fukuoka: {num: 0, img: "⓪"},
        shizuoka: {num: 0, img: "⓪"},
        hyogo: {num: 0, img: "⓪"},
        hokkaido: {num: 0, img: "⓪"},
        gunma: {num: 0, img: "⓪"},
        kagoshima: {num: 0, img: "⓪"}
      },
      selectMember: []
      
    }
  },
  mounted: function() {
    this.mapCreate();
    this.osaka = this.$store.state.osakaMembers;
    this.tokyo = this.$store.state.tokyoMembers;
    this.fukuoka = this.$store.state.fukuokaMembers;
    this.shizuoka = this.$store.state.shizuokaMembers;
    this.hyogo = this.$store.state.hyogoMembers;
    this.hokkaido = this.$store.state.hokkaidoMembers;
    this.gunma = this.$store.state.gunmaMembers;
    this.kagoshima = this.$store.state.kagoshimaMembers;
  },
  watch: {
    osaka: function () {
      this.number = {
        osaka: {num: this.osaka.length, img: this.numberImg(this.osaka.length)},
        tokyo: {num: this.tokyo.length, img: this.numberImg(this.tokyo.length)},
        fukuoka: {num: this.fukuoka.length, img: this.numberImg(this.fukuoka.length)},
        shizuoka: {num: this.shizuoka.length, img: this.numberImg(this.shizuoka.length)},
        hyogo: {num: this.hyogo.length, img: this.numberImg(this.hyogo.length)},
        hokkaido: {num: this.hokkaido.length, img: this.numberImg(this.hokkaido.length)},
        gunma: {num: this.gunma.length, img: this.numberImg(this.gunma.length)},
        kagoshima: {num: this.kagoshima.length, img: this.numberImg(this.kagoshima.length)}
      }
    }
  },
  computed: {
    members() {
      return this.$store.state.members;
    }
  },
  methods: {
    numberImg: function(i) {
      if (i == 0) {
        return "⓪";
      }
      if (i == 1) {
        return "①";
      }
    },
    mapCreate: function() {
      mapboxgl.accessToken = "pk.eyJ1IjoieXVkYWkxMTA2IiwiYSI6ImNreDdjanAwbDMxYzgydnFvdHZoNTlxeXUifQ.yyJf9YCV5A2LE2HEcJ51SQ";
    var bounds = [
      [115, 30],
      [160, 46]
    ]
    const map = new mapboxgl.Map({
      container: "mapBase",
      style: "mapbox://styles/yudai1106/ckx7n6ely1n7214pakcntjihe",
      center: [139.7671, 35.6812],
      zoom: 1,
      attributionControl: false,
      maxBounds: bounds
    });

      map.on("load", () => {
        map.loadImage(
        "/static/img/member/pic01.png",
        (error, image) => {
          if (error) throw error;
          map.setPaintProperty("water", "fill-color", "#000000");
        }
      );
    });

    map.doubleClickZoom.disable();
    map.keyboard.disable();
    map.dragRotate.disable();
    map.touchZoomRotate.disable();

    const slider = document.getElementById("sliderValue");
    slider.min = map.getZoom() * 10;

    function check() {
      const hoge = slider.value / 10;
      map.flyTo({zoom: hoge});
    }
    slider.addEventListener('input', check);

    window.addEventListener("mousewheel", () => {
      let zoomLevel = map.getZoom();
      slider.value = zoomLevel * 10;
    });

    const geoAll = [
      {
        "geometry": [141.7049, 43.6351],
        "name": "HOKKAIDO",
        "id": document.getElementById("hogeHokkaido")
      }, 
      {
        "geometry": [139.0339, 36.5328],
        "name": "GUNMA",
        "id": document.getElementById("hogeGunma")
      },
      {
        "geometry": [139.2671, 35.7512],
        "name": "TOKYO",
        "id": document.getElementById("hogeTokyo")
      },
      {
        "geometry": [137.8259, 35.0837],
        "name": "SHIZUOKA",
        "id": document.getElementById("hogeShizuoka")
      },
      {
        "geometry": [135.4112, 34.7111],
        "name": "OSAKA",
        "id": document.getElementById("hogeOsaka")
      },
      {
        "geometry": [134.5059, 35.3129],
        "name": "HYOGO",
        "id": document.getElementById("hogeHyogo")
      },
      {
        "geometry": [130.3505, 33.6623],
        "name": "FUKUOKA",
        "id": document.getElementById("hogeFukuoka")
      },
      {
        "geometry": [130.2329, 31.7337],
        "name": "KAGOSHIMA",
        "id": document.getElementById("hogeKagoshima")
      }
    ];

    function hogeGeo(a, b) {
      a.style.top = b.y + 15 + "px";
      a.style.left = b.x + "px";
    }

    function hoverGeo(a, b) {
      a.style.top = b.y + -180 + "px";
      a.style.left = b.x + 60 + "px";
    }

    function hogeGeo2(a, b) {
      a.style.top = b.y + "px";
      a.style.left = b.x + "px";
    }

    for (let a = 0; a < geoAll.length; a++) {
      hogeGeo(geoAll[a].id, map.project(geoAll[a].geometry));
    }

    const gunma = document.getElementById("hogeGunma");
    const tokyo = document.getElementById("hogeTokyo");
    const shizuoka = document.getElementById("hogeShizuoka");
    const osaka = document.getElementById("hogeOsaka");
    const fukuoka = document.getElementById("hogeFukuoka");
    const kagoshima = document.getElementById("hogeKagoshima");
    const hyogo = document.getElementById("hogeHyogo");
    const hokkaido = document.getElementById("hogeHokkaido");

    window.setTimeout(() => {
      gunma.style.opacity = 1;
      tokyo.style.opacity = 1;
      shizuoka.style.opacity = 1;
      osaka.style.opacity = 1;
      fukuoka.style.opacity = 1;
      kagoshima.style.opacity = 1;
      hyogo.style.opacity = 1;
      hokkaido.style.opacity = 1;
      setInterval(() => {
        for (let a = 0; a < geoAll.length; a++) {
          hogeGeo2(geoAll[a].id, map.project(geoAll[a].geometry));
        }
      }, 10);
    }, 500);
    
    window.setTimeout(() => {
      gunma.style.transition = "0s";
      tokyo.style.transition = "0s";
      shizuoka.style.transition = "0s";
      osaka.style.transition = "0s";
      fukuoka.style.transition = "0s";
      kagoshima.style.transition = "0s";
      hyogo.style.transition = "0s";
      hokkaido.style.transition = "0s";
    }, 1000);

    const target = document.getElementById("hover");
    const preClass = document.querySelectorAll(".pre");

    var timeBomb;
    const sliderHover = document.getElementById("slider");
    const blurBase = document.getElementById("blurBase");

    for (let i = 0; i < geoAll.length; i++) {
      geoAll[i].id.addEventListener("mouseenter", () => {
        clearTimeout(timeBomb);
        target.getElementsByTagName("h1")[0].textContent = geoAll[i].name;
        hoverGeo(target, map.project(geoAll[i].geometry));

        if (geoAll[i].name == "TOKYO") {
          this.selectMember = this.tokyo;
        }
        if (geoAll[i].name == "OSAKA") {
          this.selectMember = this.osaka;
        }
        if (geoAll[i].name == "HOKKAIDO") {
          this.selectMember = this.hokkaido;
        }
        if (geoAll[i].name == "GUNMA") {
          this.selectMember = this.gunma;
        }
        if (geoAll[i].name == "HYOGO") {
          this.selectMember = this.hyogo;
        }
        if (geoAll[i].name == "SHIZUOKA") {
          this.selectMember = this.shizuoka;
        }
        if (geoAll[i].name == "FUKUOKA") {
          this.selectMember = this.fukuoka;
        }
        if (geoAll[i].name == "KAGOSHIMA") {
          this.selectMember = this.kagoshima;
        }

        base.style.display = "block";
        setTimeout(() => {
          base.style.opacity = 1;
        }, 10);
        
        for (let c = 0; c < preClass.length; c++) {
          preClass[c].style.opacity = 0.3;
        }

        let littleWord = geoAll[i].name.toLowerCase();
        let item = document.getElementById(littleWord);

        item.style.opacity = 1;

        blurBase.style.filter = "blur(3px)";

        sliderHover.style.opacity = 0;
      });

      geoAll[i].id.addEventListener("mouseleave", () => {
        base.style.opacity = 0;
        timeBomb = setTimeout(function() {
          base.style.display = "none";
        }, 800);
        for (let d = 0; d < preClass.length; d ++) {
          preClass[d].style.opacity = 1;
        }
        blurBase.style.filter = "blur(0)";

        sliderHover.style.opacity = 1;
      });
    }

    let lastClass = Array.from(preClass);

    var sheets = document.styleSheets,
    sheet = sheets[sheets.length - 1];

    const mapId = document.getElementById("mapBase");

    window.setTimeout(() => {
      this.load += 1;
    }, 1000);

    lastClass.forEach((e) => {
      e.addEventListener("mouseenter", () => {
        clearTimeout(timeBomb);
        preClass.forEach((x) => {
          x.style.opacity = 0.3;
        });

        e.style.opacity = 1;
        
        let preName = e.textContent.split(" ");
        target.getElementsByTagName("h1")[0].textContent = preName[1];
        if (preName[1] == "TOKYO") {
          this.selectMember = this.tokyo;
        }
        if (preName[1] == "OSAKA") {
          this.selectMember = this.osaka;
        }
        if (preName[1] == "HOKKAIDO") {
          this.selectMember = this.hokkaido;
        }
        if (preName[1] == "GUNMA") {
          this.selectMember = this.gunma;
        }
        if (preName[1] == "HYOGO") {
          this.selectMember = this.hyogo;
        }
        if (preName[1] == "SHIZUOKA") {
          this.selectMember = this.shizuoka;
        }
        if (preName[1] == "FUKUOKA") {
          this.selectMember = this.fukuoka;
        }
        if (preName[1] == "KAGOSHIMA") {
          this.selectMember = this.kagoshima;
        }

        let geometry;

        geoAll.forEach((a) => {
          if (preName[1] == a.name) {
            return geometry = a.geometry;
          }
        });


        hoverGeo(target, map.project(geometry));

        base.style.display = "block";
        setTimeout(() => {
          base.style.opacity = 1;
        }, 10);

        blurBase.style.filter = "blur(3px)";
        
        sliderHover.style.opacity = 0;
      });

      e.addEventListener("mouseleave", () => {
        base.style.opacity = 0;
        timeBomb = setTimeout(() => {
          base.style.display = "none"
        }, 800);
        preClass.forEach((x) => {
          x.style.opacity = 1;
        });

        blurBase.style.filter = "blur(0)";

        sliderHover.style.opacity = 1;
      });
    });
    }
  }
};
</script>

<style scoped>
.contents {
  height: 100%;
}

#baseBody {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}

#mapBase {
  position: relative;
  transition: 0.5s;
  cursor: default;
}

#blurBase {
  transition: 0.5s;
}

#mapBase canvas {
  cursor: default;
}

#slider {
  position: absolute;
  top: 50%;
  right: -1%;
  transform: rotate(-90deg);
  transition: 0.5s;
  cursor: default;
}

#slider label {
  display: flex;
  align-items: center;
  cursor: default;
}

#sliderValue {
  -webkit-appearance: none;
  appearance: none;
  background: #8d8d8d;
  height: 1px;
  width: 100%;
  border-radius: 10px;
  border: none;
  outline: 0;
  rotate: 30;
}

#sliderValue::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 12px;
  width: 12px;
  background: #fff;
  border-radius: 50%;
  cursor: grab;
}

.point {
  color: white;
  padding-left: 10px;
  padding-right: 10px;
  transform: rotate(90deg);
  font-size: 10px;
}

#base {
  background-color: rgba(255, 255, 255, 0.274);
  opacity: 0;
  display: none;
  transition: 0.5s;
  position: relative;
  width: 330px;
  height: 190px;
}

#base h1 {
  color: white;
  position: absolute;
  top: -37px;
  left: 20px;
  margin: 0;
  font-size: 60px;
}

/* 地名 */
#hogeHokkaido p,
#hogeGunma p,
#hogeTokyo p,
#hogeShizuoka p,
#hogeOsaka p,
#hogeHyogo p,
#hogeFukuoka p,
#hogeKagoshima p {
  color: white;
  margin: 0;
  font-size: 12px;
  display: flex;
  align-items: center;
  font-weight: 600;
}

.number img {
  width: 15px;
  height: 15px;
}

#hogeHokkaido,
#hogeGunma,
#hogeTokyo,
#hogeShizuoka,
#hogeOsaka,
#hogeHyogo,
#hogeFukuoka,
#hogeKagoshima {
  position: absolute;
  z-index:1;
  cursor: pointer;
  opacity: 0;
  transition: 2.0s;
}

#hover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
}

.people img {
  width: 30px;
  border-radius: 50%;
}

.people ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding-top: 25px;
  justify-content: space-between;
  padding-left: 25px;
  padding-right: 20px;
  flex-wrap: wrap;
}

.people li {
  width: 45%;
  display: flex;
  padding-top: 13px;
}

.name {
  margin-left: 10px;
}

.right {
  margin-left: 20px;
}

.people p {
  color: white;
  margin: 0;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: lighter;
}

.little {
  opacity: 0.5;
  font-size: 9px!important;
  letter-spacing: 0px!important;
}

#hokkaido,
#gunma,
#shizuoka,
#tokyo,
#osaka,
#hyogo,
#fukuoka,
#kagoshima {
  transition: 0.5s;
  cursor: default;
  display: flex;
  font-weight: 100;
  margin-bottom: 10px!important;
  cursor: pointer;
}

.number {
  padding-left: 5px;
  font-size: 20px;
  font-weight: 100!important;
  padding-bottom: 2.2px;
}

#pre {
  position: absolute;
  top: -27px;
  margin: 0;
  color: white;
  font-size: 40px;
}

#text {
  position: absolute;
  color: white;
  top: 80px;
  left: 78px;
  z-index: 99;
  font-size: 12px;
}

#text ul {
  list-style: none;
  padding-left: 0;
  margin-top: 25px;
}

#text li {
  letter-spacing: 1px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.Blank {
  width: 20px;
  display: block;
  text-align: center;
}

.Blank2 {
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Map/index.vue